var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button, CircularProgress, Grid, Paper, Stack, Typography, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useDataProvider, useLocale, useNotify, useTranslate, } from "react-admin";
import FundusImagePreview from "../examsPage/fp/FundusImagePreview";
import { StatusChip } from "./BatchProgress";
var formatDateOnly = function (value) {
    return value ? String(value).split("T")[0].split(" ")[0] : "";
};
var isExamCompleted = function (status) {
    return status === "Completed" || (status === null || status === void 0 ? void 0 : status.toUpperCase()) === "COMPLETED";
};
var LabeledStatus = function (_a) {
    var label = _a.label, status = _a.status, _b = _a.align, align = _b === void 0 ? "flex-start" : _b;
    return (_jsxs(Stack, { spacing: 0.5, alignItems: align, children: [_jsx(Typography, { variant: "caption", color: "text.secondary", lineHeight: 1.2, children: label }), status ? (_jsx(StatusChip, { status: status })) : (_jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u2014" }))] }));
};
var BatchPreview = function (_a) {
    var batchId = _a.batchId, _b = _a.refreshKey, refreshKey = _b === void 0 ? 0 : _b, _c = _a.allowRegenerate, allowRegenerate = _c === void 0 ? true : _c, onQuotaChange = _a.onQuotaChange;
    var dataProvider = useDataProvider();
    var translate = useTranslate();
    var notify = useNotify();
    var locale = useLocale();
    var _d = useState([]), subjects = _d[0], setSubjects = _d[1];
    var _e = useState([]), exams = _e[0], setExams = _e[1];
    var _f = useState([]), expandedSubjectIds = _f[0], setExpandedSubjectIds = _f[1];
    var _g = useState([]), loadedSubjectIds = _g[0], setLoadedSubjectIds = _g[1];
    var _h = useState([]), loadingSubjectIds = _h[0], setLoadingSubjectIds = _h[1];
    var _j = useState(true), loading = _j[0], setLoading = _j[1];
    var _k = useState(null), regeneratingExamId = _k[0], setRegeneratingExamId = _k[1];
    var _l = useState(null), error = _l[0], setError = _l[1];
    useEffect(function () {
        var active = true;
        setLoading(true);
        setError(null);
        setExpandedSubjectIds([]);
        setLoadedSubjectIds([]);
        setLoadingSubjectIds([]);
        Promise.all([
            dataProvider.getBatchSubjects(batchId),
            dataProvider.getBatchExams(batchId),
        ])
            .then(function (_a) {
            var subjectResponse = _a[0], examResponse = _a[1];
            if (!active)
                return;
            setSubjects(subjectResponse.data);
            setExams(examResponse.data);
        })
            .catch(function (caughtError) {
            if (active) {
                setError((caughtError === null || caughtError === void 0 ? void 0 : caughtError.message) || translate("pages.bulkGeneration.notify.previewFailed"));
            }
        })
            .finally(function () {
            if (active)
                setLoading(false);
        });
        return function () {
            active = false;
        };
    }, [batchId, dataProvider, refreshKey, translate]);
    var examsBySubject = useMemo(function () {
        var grouped = new Map();
        exams.forEach(function (exam) {
            grouped.set(exam.batch_subject_id, __spreadArray(__spreadArray([], (grouped.get(exam.batch_subject_id) || []), true), [
                exam,
            ], false));
        });
        return grouped;
    }, [exams]);
    var loadSubjectDetails = function (subject) { return __awaiter(void 0, void 0, void 0, function () {
        var subjectExams, _a, subjectResponse_1, examResponses_1, examDetails_1, caughtError_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!subject.subject_id || loadedSubjectIds.includes(subject.id))
                        return [2 /*return*/];
                    setLoadingSubjectIds(function (current) { return __spreadArray(__spreadArray([], current, true), [subject.id], false); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    subjectExams = exams.filter(function (exam) { return exam.batch_subject_id === subject.id; });
                    return [4 /*yield*/, Promise.all(__spreadArray([
                            dataProvider.getOne("subjects", { id: subject.subject_id })
                        ], subjectExams.map(function (exam) {
                            return exam.exam_id
                                ? dataProvider.getBatchExam(subject.subject_id, exam.exam_id)
                                : Promise.resolve({ data: undefined });
                        }), true))];
                case 2:
                    _a = _b.sent(), subjectResponse_1 = _a[0], examResponses_1 = _a.slice(1);
                    setSubjects(function (current) {
                        return current.map(function (item) {
                            return item.id === subject.id
                                ? __assign(__assign({}, item), { details: subjectResponse_1.data }) : item;
                        });
                    });
                    examDetails_1 = new Map(subjectExams.map(function (exam, index) { return [
                        exam.id,
                        examResponses_1[index].data,
                    ]; }));
                    setExams(function (current) {
                        return current.map(function (exam) {
                            var details = examDetails_1.get(exam.id);
                            return details
                                ? __assign(__assign(__assign({}, exam), details), { id: exam.id, fp_imgs: details.fp_imgs || [] }) : exam;
                        });
                    });
                    setLoadedSubjectIds(function (current) { return __spreadArray(__spreadArray([], current, true), [subject.id], false); });
                    return [3 /*break*/, 5];
                case 3:
                    caughtError_1 = _b.sent();
                    notify((caughtError_1 === null || caughtError_1 === void 0 ? void 0 : caughtError_1.message) ||
                        translate("pages.bulkGeneration.notify.previewFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingSubjectIds(function (current) {
                        return current.filter(function (id) { return id !== subject.id; });
                    });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSubjectChange = function (subject) { return function (_event, expanded) {
        setExpandedSubjectIds(function (current) {
            return expanded
                ? __spreadArray(__spreadArray([], current, true), [subject.id], false) : current.filter(function (id) { return id !== subject.id; });
        });
        if (expanded)
            void loadSubjectDetails(subject);
    }; };
    var regenerateExam = function (exam) { return __awaiter(void 0, void 0, void 0, function () {
        var caughtError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!exam.exam_id || !exam.subject_id)
                        return [2 /*return*/];
                    setRegeneratingExamId(exam.exam_id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, dataProvider.triggerExamAnalysis({
                            data: {
                                subjectId: exam.subject_id,
                                examId: exam.exam_id,
                                language: locale,
                            },
                        })];
                case 2:
                    _a.sent();
                    notify(translate("pages.bulkGeneration.notify.examRegenerated"), {
                        type: "success",
                    });
                    return [4 /*yield*/, (onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange())];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    caughtError_2 = _a.sent();
                    notify((caughtError_2 === null || caughtError_2 === void 0 ? void 0 : caughtError_2.message) ||
                        translate("pages.bulkGeneration.notify.examRegenerateFailed"), { type: "error" });
                    return [3 /*break*/, 6];
                case 5:
                    setRegeneratingExamId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    if (loading) {
        return (_jsx(Box, { display: "flex", justifyContent: "center", py: 6, children: _jsx(CircularProgress, {}) }));
    }
    if (error)
        return _jsx(Alert, { severity: "error", children: error });
    if (subjects.length === 0) {
        return _jsx(Alert, { severity: "info", children: translate("pages.bulkGeneration.preview.empty") });
    }
    return (_jsx(Stack, { spacing: 2, children: subjects.map(function (subject) {
            var details = subject.details || {};
            var subjectExams = examsBySubject.get(subject.id) || [];
            var subjectLoading = loadingSubjectIds.includes(subject.id);
            return (_jsxs(Accordion, { expanded: expandedSubjectIds.includes(subject.id), onChange: handleSubjectChange(subject), disableGutters: true, sx: {
                    border: 1,
                    borderColor: "divider",
                    borderRadius: "8px !important",
                    overflow: "hidden",
                    "&:before": { display: "none" },
                }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), sx: { bgcolor: "grey.50", borderLeft: 4, borderColor: "primary.main" }, children: _jsxs(Stack, { direction: "row", justifyContent: "space-between", spacing: 1, alignItems: "center", width: "100%", children: [_jsx(Typography, { fontWeight: 600, children: String(details.customId || subject.source_key) }), _jsx(LabeledStatus, { label: translate("pages.bulkGeneration.preview.subjectImportStatus"), status: subject.import_status, align: "flex-end" })] }) }), _jsxs(AccordionDetails, { sx: { p: { xs: 2, md: 3 } }, children: [subjectLoading && (_jsx(Box, { display: "flex", justifyContent: "center", py: 4, children: _jsx(CircularProgress, { size: 28 }) })), _jsxs(Box, { display: subjectLoading ? "none" : "block", children: [subject.import_error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: subject.import_error })), _jsx(Typography, { variant: "subtitle2", color: "primary", mb: 1.5, children: translate("pages.subject.fields.info") }), _jsx(Grid, { container: true, spacing: 2, mb: 3, children: [
                                            [
                                                "pages.subject.fields.customId",
                                                details.customId || subject.source_key,
                                            ],
                                            ["pages.subject.fields.firstname", details.firstname],
                                            ["pages.subject.fields.lastname", details.lastname],
                                            ["pages.subject.fields.gender", details.gender],
                                            ["pages.subject.fields.educationLevel", details.educationLevel],
                                            [
                                                "pages.subject.fields.dateOfBirth",
                                                formatDateOnly(details.dateOfBirth),
                                            ],
                                            [
                                                "pages.bulkGeneration.preview.sourceRow",
                                                subject.source_row_number,
                                            ],
                                        ].map(function (_a) {
                                            var label = _a[0], value = _a[1];
                                            return (_jsxs(Grid, { item: true, xs: 12, sm: 6, md: 4, children: [_jsx(Typography, { variant: "caption", color: "text.secondary", children: translate(String(label)) }), _jsx(Typography, { variant: "body2", fontWeight: 500, children: value ? String(value) : "—" })] }, String(label)));
                                        }) }), _jsx(Stack, { spacing: 2.5, children: subjectExams.map(function (exam) { return (_jsxs(Paper, { variant: "outlined", sx: { p: 2.5, borderRadius: 2, boxShadow: "0 3px 12px rgba(0,0,0,0.04)" }, children: [exam.import_error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: exam.import_error })), _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, md: 4, children: _jsxs(Stack, { spacing: 2, height: "100%", children: [_jsx(Typography, { variant: "subtitle1", fontWeight: 700, children: exam.source_exam_key || exam.source_folder }), _jsx(Stack, { direction: "row", spacing: 2.5, flexWrap: "wrap", useFlexGap: true, children: _jsx(LabeledStatus, { label: translate("pages.bulkGeneration.preview.examImportStatus"), status: exam.import_status }) }), [
                                                                        ["examDate", formatDateOnly(exam.exam_date)],
                                                                        ["aiModel", exam.ai_model],
                                                                        ["eye", exam.eye],
                                                                        ["examStatus", exam.status],
                                                                    ].map(function (_a) {
                                                                        var field = _a[0], value = _a[1];
                                                                        return (_jsxs(Box, { children: [_jsx(Typography, { variant: "caption", color: "text.secondary", children: translate("pages.bulkGeneration.preview.".concat(String(field))) }), field === "examStatus" && value ? (_jsx(Box, { mt: 0.5, children: _jsx(StatusChip, { status: String(value) }) })) : (_jsx(Typography, { variant: "body2", fontWeight: 500, children: value ? String(value) : "—" }))] }, String(field)));
                                                                    })] }) }), _jsx(Grid, { item: true, xs: 12, md: 8, children: exam.fp_imgs && exam.fp_imgs.length > 0 ? (_jsx(FundusImagePreview, { images: exam.fp_imgs })) : (_jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", justifyContent: "center", minHeight: 220, children: [_jsx(ImageNotSupportedIcon, { color: "disabled" }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: translate("pages.bulkGeneration.preview.noImages") })] })) })] }), (function () {
                                                    var examCompleted = isExamCompleted(exam.status);
                                                    var canViewReport = examCompleted && Boolean(exam.analysisDataPdf);
                                                    var canRegenerateExam = allowRegenerate &&
                                                        examCompleted &&
                                                        exam.exam_id &&
                                                        exam.subject_id;
                                                    if (!canViewReport && !canRegenerateExam) {
                                                        return null;
                                                    }
                                                    return (_jsxs(Stack, { direction: "row", justifyContent: "flex-end", spacing: 1.5, mt: 2.5, children: [canRegenerateExam && (_jsx(Button, { size: "small", variant: "outlined", startIcon: regeneratingExamId === exam.exam_id
                                                                    ? _jsx(CircularProgress, { size: 16 })
                                                                    : _jsx(RestartAltIcon, {}), disabled: Boolean(regeneratingExamId), onClick: function () { return regenerateExam(exam); }, children: translate("pages.bulkGeneration.actions.regenerateExam") })), canViewReport && (_jsx(Button, { size: "small", variant: "contained", startIcon: _jsx(VisibilityOutlinedIcon, {}), onClick: function () {
                                                                    return window.open(exam.analysisDataPdf, "_blank", "noopener,noreferrer");
                                                                }, children: translate("pages.bulkGeneration.actions.viewReport") }))] }));
                                                })()] }, exam.id)); }) })] })] })] }, subject.id));
        }) }));
};
export default BatchPreview;
